export const WEBHOOK_EVENT_STATUSES = [
  { value: 'received', text: 'Recibido' },
  { value: 'processing', text: 'Procesando' },
  { value: 'processed', text: 'Procesado' },
  { value: 'failed', text: 'Fallido' }
]

export const WEBHOOK_EVENT_SOURCES = [
  { value: 'shopify', text: 'Shopify' },
  { value: 'jumpseller', text: 'Jumpseller' }
]

export const WEBHOOK_EVENT_PAGE_SIZES = [25, 50, 100]

export const emptyWebhookEventFilters = () => ({
  startDate: '',
  endDate: '',
  status: '',
  source: '',
  storeId: null
})

/**
 * Query params para GET /webhook-events: solo los filtros con valor, más la
 * paginación.
 */
export const buildWebhookEventQuery = (filters = {}, { page = 1, limit = 50 } = {}) => {
  const query = {}
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      query[key] = value
    }
  })
  return { ...query, page, limit }
}

export const webhookEventStatusLabel = (status) => {
  const found = WEBHOOK_EVENT_STATUSES.find(item => item.value === status)
  return found ? found.text : status
}

/** Payload legible: JSON indentado; los strings se muestran tal cual. */
export const formatWebhookPayload = (payload) => {
  if (payload === null || payload === undefined) return ''
  if (typeof payload === 'string') return payload
  return JSON.stringify(payload, null, 2)
}
